<template>
    <div class="offerDetailMore">
        <div class="title ben-border-t">
            <span class="ben-000-color ben-size-15 ben-text-bold ">补充说明</span>
        </div>
        <div class="demand-comm ben-000-colo ben-size-12">
           <p v-if="data.wantBuyAndDetails.added!==''">
                {{data.wantBuyAndDetails.added}}
            </p>
            
            <p v-else>暂无说明</p>
        </div>
    </div>
</template>
<script>
export default {
    name:'offerDetailMore',
    props:{
        data : {
            type : Object
        }
    },
    components: {
    },
    data () {
        return {
        
        }
    },
    
    methods: {
        
    },
    
}

</script>


<style lang='scss' scoped>
.offerDetailMore{
     background: #fff;
        margin-top: 10px;
        .demand-comm{
            padding: 15px;
            word-break: break-word;
        }
        .title{
            padding: 20px 15px 10px 15px;
            >span{
                border-bottom: 3px solid #C41335;
                padding-bottom: 10px;

            }
        }
}
</style>


// WEBPACK FOOTER //
// src/view/procurement/components/offerDetailMore.vue